/**
 * @generated SignedSource<<2ab9659723ea24890f91851405c29d4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserDefaultPhoto_user$data = {
  readonly emailMd5: string | null | undefined;
  readonly legacyDefaultAvatarUrl: string;
  readonly rowId: string;
  readonly " $fragmentType": "UserDefaultPhoto_user";
};
export type UserDefaultPhoto_user$key = {
  readonly " $data"?: UserDefaultPhoto_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserDefaultPhoto_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserDefaultPhoto_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailMd5",
      "storageKey": null
    },
    {
      "alias": "legacyDefaultAvatarUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "transform",
          "value": {
            "dpr": 3,
            "fo": "auto",
            "h": 48,
            "w": 48
          }
        }
      ],
      "kind": "ScalarField",
      "name": "defaultAvatarUrl",
      "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":48,\"w\":48})"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "25a8413b4784368b0504ab1df5ad703a";

export default node;
